import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { FilterKeys } from '../../../../../shared/projectsV2/filters';
import * as ProjectsV2Store from '../../../../redux/projectsV2';
import FilterCardCheckboxes from '../../../generic/Filter/FilterCardCheckboxes';
import FilterPanel from '../../../generic/Filter/FilterPanel';
import useFetchProjectsAction from '../hooks/useFetchProjectsAction';
import type { ProjectComponent } from '../../../../../shared/projectsV2/common';
import type { ProjectsFilter } from '../../../../../shared/projectsV2/filters';
import type { SelectOption } from '../../../../types';

const FILTER_OPTIONS: SelectOption[] = [
  { value: 'vendored', label: 'Vendored Dependencies' },
  { value: 'snippet', label: 'Snippets' },
];

type Props = {
  isSnippetsEnabled: boolean;
  isVendoredEnabled: boolean;
};

const ProjectInventory: VoidFunctionComponent<Props> = ({ isSnippetsEnabled, isVendoredEnabled }) => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter) as ProjectsFilter;
  const setFilter = useFetchProjectsAction(ProjectsV2Store.actions.setFilter);

  // ProjectInventory should not be displayed if both are false; this is a guard
  if (!isSnippetsEnabled && !isVendoredEnabled) {
    return null;
  }

  // handle onChange from FilterCardCheckboxes
  const onChange = (newSelected: SelectOption[]) => {
    const selectedTypes = newSelected.map(({ value }) => value as ProjectComponent);
    setFilter({ ...filter, [FilterKeys.Inventory]: selectedTypes });
  };

  // map current filter.type to SelectOption format
  const selectedCheckboxes = (filter.inventory ?? []).map((component: string) => ({
    label: FILTER_OPTIONS.find(option => option.value === component)?.label || component,
    value: component,
  }));

  let options = FILTER_OPTIONS;

  if (!isVendoredEnabled) {
    options = options.filter(entry => entry.value !== 'vendored');
  }

  if (!isSnippetsEnabled) {
    options = options.filter(entry => entry.value !== 'snippet');
  }

  return (
    <FilterPanel>
      <FilterCardCheckboxes
        label="Inventory"
        options={options}
        values={selectedCheckboxes}
        onChange={onChange}
      />
    </FilterPanel>
  );
};

export default ProjectInventory;
